import styled from '@emotion/styled';

import { Card } from '@/components/common/Card';
import { Paragraph } from '@/components/common/MarkUp';

import type { ReactNode } from 'react';

interface TestimonialCardProps {
  body: string;
  author?: string;
  authorCaption?: string;
  image?: ReactNode;
}

export const TestimonialCard = ({
  body,
  author,
  authorCaption,
  image,
}: TestimonialCardProps) => {
  return (
    <Card
      borderRadius="m"
      backdropBlur
      horizontalPadding={200}
      verticalPadding={150}
    >
      {image}
      <Quote size="body-lg">{body}</Quote>
      <Caption size="label-md">
        {author && <Author>{`${author}  - `}</Author>}
        {authorCaption}
      </Caption>
    </Card>
  );
};

const Quote = styled(Paragraph)`
  margin-top: var(--spacing-xxx-small, 4px);
`;

const Author = styled.span`
  color: var(--text-strong);
`;

const Caption = styled(Paragraph)`
  color: var(--text-warm-subtle);
  margin-top: var(--spacing-xxx-small, 4px);
`;
